<template>
  <div class="mb-6 mt-8">
    <div class="vx-col w-1/1.5">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Operating Unit</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="vx-col w-1/2">
            <OperatingUnit
              :value="this.selectedoperatingUnit" @selected="(val) => { this.selectedoperatingUnit = val }"
              v-validate="'required'"></OperatingUnit>
            <span class="text-danger text-sm" v-show="errors.has('Operating Unit')">{{
                errors.first("Operating Unit")
              }}</span>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Warehouse Code</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="vx-col w-1/2">
            <Warehouse
              :warehouseID="this.selectedoperatingUnit ? this.selectedoperatingUnit.warehouse_id : null"
              :value="this.selectedWarehouse" @selected="(val) => {
                    this.selectedWarehouse = val
                }" v-validate="'required'"></Warehouse>
            <span class="text-danger text-sm" v-show="errors.has('Warehouse')">{{ errors.first("Warehouse") }}</span>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Document Date</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="vx-col w-1/2">
            <DateComponent
              :default="true"
              @selected="(val) => { this.countingDate = val }"
              v-validate="'required'"
              :disabled-dates="true"
            ></DateComponent>
            <span class="text-danger text-sm" v-show="errors.has('Counting Date')">{{
                errors.first("Counting Date")
              }}</span>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>SAF Type</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="vx-col w-1/2">
            <SafType
              v-model="safType"
              @selected="handleSafTypeChange"
              v-validate="'required'"></SafType>
            <span class="text-danger text-sm" v-show="errors.has('SAF Type')">{{ errors.first("SAF Type") }}</span>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="!isToWarehouse">
        <div class="vx-col sm:w-1/5 w-full">
          <span>To Warehouse Code</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="vx-col w-1/2">
            <ToWarehouse :value="this.selectedToWarehouse" @selected="(val) => {
                    this.selectedToWarehouse = val
                }" v-validate="'required'"></ToWarehouse>
            <span class="text-danger text-sm" v-show="errors.has('To Warehouse')">{{
                errors.first("To Warehouse")
              }}</span>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="!isCOADisabled">
        <div class="vx-col sm:w-1/5 w-full">
          <span>COA</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="vx-col w-1/2">
            <COA
              :value="this.selectedCOA" @selected="(val) => { this.selectedCOA = val }"
              v-validate="'required'"></COA>
            <span class="text-danger text-sm" v-show="errors.has('COA')">{{ errors.first("COA") }}</span>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="!isCostCenterDisabled">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Cost Center</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="vx-col w-1/2">
            <CostCenter
              :value="this.selectedCostCenter"
              @selected="(val) => { this.selectedCostCenter = val }"
              v-validate="'required'"></CostCenter>
            <span class="text-danger text-sm" v-show="errors.has('Cost Center')">{{
                errors.first("Cost Center")
              }}</span>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>External Code</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="vx-col w-1/2">
            <vs-input class="w-full" v-model="external_code"></vs-input>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Note</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <div class="vx-col w-1/2">
            <vs-textarea v-model="note" class="w-full" v-validate="'required'"/>
            <span class="text-danger text-sm" v-show="errors.has('Note')">{{ errors.first("Note") }}</span>
          </div>
        </div>
      </div>

      <Attachment
        v-model="fileAttachment"
        v-validate="'required'"
      ></Attachment>
      <span class="text-danger text-sm" v-show="errors.has('fileAttachment')">{{
          errors.first("fileAttachment")
        }}</span>

      <ImportExcel
        v-model="importExcel"
        @input="handleFileInput"
        v-validate="'required'"
      ></ImportExcel>
      <span class="text-danger text-sm" v-show="errors.has('importExcel')">{{ errors.first("importExcel") }}</span>

      <div class="vx-row flex justify-between mt-5 m-10">
        <div>
          <vs-button class="mb-2" v-on:click="SubmitForm()">
            Upload
          </vs-button>
        </div>
        <div>
          <vs-button class="mb-2" v-on:click="handleClose()">Close</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OperatingUnit from "./OperatingUnit.vue";
import Warehouse from "./Warehouse.vue";
import DateComponent from "./Date.vue";
import SafType from "./SafType.vue";
import COA from "./COA.vue"
import CostCenter from "./CostCenter.vue"
import Attachment from "./Attachment.vue"
import ImportExcel from "./ImportExcel.vue"
import ToWarehouse from "./ToWarehouse.vue"
import moment from "moment/moment";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    OperatingUnit,
    Warehouse,
    DateComponent,
    SafType,
    COA,
    CostCenter,
    Attachment,
    ImportExcel,
    ToWarehouse,
    Datepicker,
  },
  data() {
    return {
      isCOADisabled: false,
      isToWarehouse: false,
      isCostCenterDisabled: false,
      countingDate: null,
      postingDate: null,
      selectedWarehouse: null,
      safType: null,
      selectedoperatingUnit: null,
      selectedCOA: null,
      selectedCostCenter: null,
      fileAttachment: [],
      importExcel: null,
      note: null,
      external_code: null,
      selectedToWarehouse: null,
    };
  },
  methods: {
    handleFileInput(file) {
      this.importExcel = file;
    },
    SubmitForm() {
      this.errors.clear();
      this.$validator.validateAll().then((validationPassed) => {
        let allValidationsPassed = true; // Flag to track validation status

        if (!this.selectedoperatingUnit) {
          this.errors.add({
            field: "Operating Unit",
            msg: "This field is required",
          });
          allValidationsPassed = false;
        }

        if (!this.selectedWarehouse) {
          this.errors.add({
            field: "Warehouse",
            msg: "This field is required",
          });
          allValidationsPassed = false;
        }

        if (!this.countingDate) {
          this.errors.add({
            field: "Counting Date",
            msg: "This field is required",
          });
          allValidationsPassed = false;
        }

        if (!this.safType) {
          this.errors.add({
            field: "SAF Type",
            msg: "This field is required",
          });
          allValidationsPassed = false;
        }

        if (!this.selectedCOA && !this.isCOADisabled) {
          this.errors.add({
            field: "COA",
            msg: "This field is required",
          });
          allValidationsPassed = false;
        }

        if (!this.selectedCostCenter && !this.isCostCenterDisabled) {
          this.errors.add({
            field: "Cost Center",
            msg: "This field is required",
          });
          allValidationsPassed = false;
        }

        if (!this.selectedToWarehouse && !this.isToWarehouse) {
          this.errors.add({
            field: "To Warehouse",
            msg: "This field is required",
          });
          allValidationsPassed = false;
        }

        if (!this.note) {
          this.errors.add({
            field: "Note",
            msg: "This field is required",
          });
          allValidationsPassed = false;
        }

        if (this.fileAttachment.length === 0) {
          this.errors.add({
            field: "fileAttachment",
            msg: "This Attachment field is required",
          });
          allValidationsPassed = false;
        }

        if (!this.importExcel) {
          this.errors.add({
            field: "importExcel",
            msg: "This field is required",
          });
          allValidationsPassed = false;
        }

        if (allValidationsPassed) {
          this.postData();
        }
      });
    },
    postData() {
      let form = new FormData();
      form.append("operating_unit_code", this.selectedoperatingUnit.code);
      form.append("warehouse_code", this.selectedWarehouse.code);
      form.append("counting_date", moment(this.countingDate).format("YYYY-MM-DD"));
      form.append("posting_date", moment().format("YYYY-MM-DD"));
      form.append("saf_type", this.safType.label);
      form.append("coa_code", this.selectedCOA ? this.selectedCOA.code : "");
      form.append("cost_center_code", this.selectedCostCenter ? this.selectedCostCenter.code : "");
      form.append("note", this.note);
      form.append("external_code", this.external_code);
      form.append("to_warehouse_code", this.selectedToWarehouse ? this.selectedToWarehouse.code : "");

      for (let index = 0; index < this.fileAttachment.length; index++) {
        form.append("attachments[]", this.fileAttachment[index].File);
      }
      form.append("excel", this.importExcel);

      this.$vs.loading();
      this.$http
        .post("/api/wms/v1/stock-adjustment-form", form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((resp) => {
          if (resp.code === 200) {
            this.$vs.notify({
              title: "Success",
              text: "import running on background please wait a moment",
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.handleClose();
          } else {
            this.$vs.notify({
              title: "Error",
              text: resp.message,
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          }
          this.$vs.loading.close();
        });
    },
    handleClose() {
      this.$vs.loading();
      this.$router.push({name: "saf"});
      this.$vs.loading.close();
    },
    handleSafTypeChange(safType) {
      this.safType = safType;
      if (safType.label === 'Adjustment Stock') {
        this.isCOADisabled = true;
        this.isCostCenterDisabled = false;
        this.isToWarehouse = true;
      } else if (safType.label === 'Interwarehouse') {
        this.isCOADisabled = false;
        this.isCostCenterDisabled = true;
        this.isToWarehouse = false;
      }
    }
  }
}
</script>
